var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 42,
    height: 42,
    rx: 21,
    stroke: "#D0D0D0",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 28.6666C14.875 28.6666 14.4825 28.5033 14.1558 28.1766C13.8292 27.8499 13.6661 27.4577 13.6667 26.9999V16.9999C13.6667 16.5416 13.83 16.1491 14.1567 15.8224C14.4833 15.4958 14.8756 15.3327 15.3333 15.3333H28.6667C29.125 15.3333 29.5175 15.4966 29.8442 15.8233C30.1708 16.1499 30.3339 16.5421 30.3333 16.9999V26.9999C30.3333 27.4583 30.17 27.8508 29.8433 28.1774C29.5167 28.5041 29.1244 28.6671 28.6667 28.6666H15.3333ZM22 22.8333L28.6667 18.6666V16.9999L22 21.1666L15.3333 16.9999V18.6666L22 22.8333Z",
    fill: "#D0D0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6b07dca1e88bdbb82898edd91a156ebc.svg";
export { ForwardRef as ReactComponent };